// extracted by mini-css-extract-plugin
export default {"videoContainer":"Video_videoContainer__PgJf7","video":"Video_video__6GwTG","playPauseButton":"Video_playPauseButton__-8VrI"};